import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const UYIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="UY" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#2E42A5"
          d="M0 2h16v1H0zM0 4h16v1H0zM0 6h16v1H0zM0 8h16v1H0zM0 10h16v1H0z"
        />
        <Path fill="#F7FCFF" d="M0 0h8v7H0z" />
        <Path
          fill="#FFD018"
          fillRule="evenodd"
          stroke="#F19900"
          strokeOpacity={0.98}
          strokeWidth={0.4}
          d="M4.614 5.518s-.511 1.06-.96 1.277c.194-.486.265-1.477.265-1.477s-1.166.462-1.575.378c.492-.344 1.175-.981 1.175-.981s-1.51-.493-1.472-.703C2.728 4.134 3.665 4 3.665 4s-1.059-1.27-.951-1.364c.16.156 1.43.82 1.43.82s.092-1.13.365-1.511c.033.269.416 1.486.416 1.486s.77-.771 1.198-.771c-.188.233-.633 1.256-.633 1.256s1.109-.018 1.53.19c-.51.072-1.405.521-1.405.521s1.165.884 1.059 1.068a5.166 5.166 0 0 0-1.348-.409s.2 1.23.038 1.508c-.158-.41-.75-1.277-.75-1.277Z"
          clipRule="evenodd"
        />
        <Path
          fill="#FFD018"
          fillRule="evenodd"
          stroke="#F19900"
          strokeOpacity={0.98}
          strokeWidth={0.4}
          d="M4.547 4.946a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
